import { render, staticRenderFns } from "./PendingReplacementsNew.vue?vue&type=template&id=5c66e05a&"
import script from "./PendingReplacementsNew.vue?vue&type=script&lang=js&"
export * from "./PendingReplacementsNew.vue?vue&type=script&lang=js&"
import style0 from "./PendingReplacementsNew.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports